import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';

/** Header component. */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'sa-header',
  imports: [RouterModule, MatButtonModule],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent {}
